import { render, staticRenderFns } from "./ThreadCourseBuilder.vue?vue&type=template&id=2efe6612&scoped=true"
import script from "./ThreadCourseBuilder.vue?vue&type=script&lang=js"
export * from "./ThreadCourseBuilder.vue?vue&type=script&lang=js"
import style0 from "./ThreadCourseBuilder.vue?vue&type=style&index=0&id=2efe6612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efe6612",
  null
  
)

export default component.exports